import { __assign } from "tslib";
import React from 'react';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import HiddenDumbView from './Hidden';
import PremiumDumbView from './Premium';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import { useIsProfileVisitorMode } from '../../utils/hooks/useIsProfileVisitorMode';
export function useDumboCommon(props) {
    var _a;
    var showBlocked = useDeviationMatureFilter(props.deviation).showBlocked;
    var isVisitorMode = useIsProfileVisitorMode();
    if (!props.deviation) {
        return null;
    }
    if (showBlocked && !props.showMatureContent) {
        return React.createElement(HiddenDumbView, __assign({}, props));
    }
    var _b = normalizePremiumFolderData((_a = props.deviation) === null || _a === void 0 ? void 0 : _a.premiumFolderData), isPremiumLocked = _b.isPremiumLocked, isPremium = _b.isPremium;
    if (props.forceBlur || isPremiumLocked || (isPremium && isVisitorMode)) {
        return (React.createElement(PremiumDumbView, __assign({ withCSSBlur: props.forceBlur || isVisitorMode }, props)));
    }
}
//# sourceMappingURL=useDumbo.js.map